/*
This is frontend library
*/
import io from "socket.io-client";
import jwt from "jsonwebtoken";
import { decrypt, encrypt } from "../flux/encdec.flux";
class SignzyMessagingService {
    socketURL = "/";
    path = "/sms";

    static encDecKey = null;

    constructor(channelId, socketURL, path) {
        if (socketURL) {
            this.socketURL = socketURL;
        }
        if (path) {
            this.path = path;
        }
        this.channelId = channelId;

        this.socket = io(this.socketURL, {
            path: this.path,
            auth: { token: jwt.sign({ channelId: this.channelId }, SignzyMessagingService.encDecKey, { expiresIn: "3h" }) },
            query: `requestId=${this.channelId}`
        });
        this.socket.on('connect', () => {
            console.log(`Socket connected id: ${this.socket.id}`);
            this.socket.emit("registerChannel", this.channelId);
        });
    }

    on(eventName, cb) {
        this.socket.on("receiveMessage", (data) => {

            if(SignzyMessagingService.encDecKey && data.data){
                if(!data.data?.eventName) {
                    try {
                        data.data = JSON.parse(decrypt(data.data, SignzyMessagingService.encDecKey));
                    } catch(err) {
                        console.error("Something went wrong while parsing socket data", err);
                    }
                }
            }

            if (data.sessionId == this.channelId) {
                if (data.data.eventName == eventName) {
                    cb(data.data.data);
                }
            }
        })
    }

    emit(eventName, data) {
        if(SignzyMessagingService.encDecKey) {
            this.socket.emit("pushMessage", {
                sessionId: this.channelId,
                data: encrypt(JSON.stringify({ eventName: eventName, data: data }), SignzyMessagingService.encDecKey),
            });
        } else {
            this.socket.emit("pushMessage", {
                sessionId: this.channelId,
                data: {
                    eventName: eventName,
                    data: data
                }
            });
        }
    }

    end() {
        this.socket.removeAllListeners();
        this.socket.disconnect();
        this.socket.close();
    }
}

export {
    SignzyMessagingService
}